<template>
	<v-data-table
		:headers="headers"
		:items="users"
		:loading="loading"
		class="elevation-1"
		:mobile-breakpoint="0"
	>
		<v-progress-linear
			slot="progress"
			color="blue"
			indeterminate
		/>
		<user-row
			slot="item"
			slot-scope="props"
			:show-organization="isAdmin"
			:user="props.item"
			@edit="onEdit"
		/>
	</v-data-table>
</template>

<script>
import UserRow from "src/view/users/UserRow";
import { types } from "src/store/modules/User.module";
import FilterAble from "src/mixins/FilterAble";

export default {
	name: "UsersTable",
	components: {
		UserRow,
	},
	props: [],
	mixins: [new FilterAble(types)],
	data () {
		return {
			loading: false,

			search: null,
			showDialog: false,
		};
	},
	computed: {
		users () {
			return this.$store.state.UserModule.users;
		},
		isAdmin () {
			return this.$store.getters.isAdmin;
		},
		headers () {
			const headers = [
				{ text: "שם", value: "name" },
				{ text: "שם משפחה", value: "last_name" },
				{ text: "שם משתמש", value: "email" },
				{ text: "מרכז", value: "company.name" },
			];
			if (this.isAdmin) {
				headers.push({ text: "שם ארגון", value: "organizations_name" });
			}
			return [...headers, ...[{ text: "פעולות" }]];
		},
	},
	methods: {
		onEdit (User) {
			this.$emit("edit", User);
		},
	},
};
</script>

<style>

</style>
